<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  /**
   * 监听浏览器刷新
   */
  // beforeCreate() {
  //   this.$router.push({
  //     // path: '/custList',
  //   });
  // },
  methods: {
    banBackspace(e) {
      if (e.keyCode === 8) {
        const tagName = e.target.nodeName;
        if (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !e.target.getAttribute('contenteditable')) {
          e.preventDefault();
        }
        if (e.target.getAttribute('readonly')) {
          e.preventDefault();
        }
      }
    },
  },
  mounted() {
    document.onkeydown = this.banBackspace;
  },
};
</script>

<style lang="scss">
// // @import "./assets/style/vars";
// // @import "./assets/css/ovflow.css";
// // * {
// //   margin: 0;
// //   padding: 0;
// // }
// // .text--green {
// //   color: $green;
// // }
// // .text--red {
// //   color: $red;
// // }
// // .text--blue {
// //   color: $blue;
// // }
// // // table 中操作按钮样式
// // .button--green {
// //   color: $green;
// //   display: inline-block;
// //   cursor: pointer;
// //   margin-right: 0.5em;
// // }
// // .button--red {
// //   color: $red;
// //   display: inline-block;
// //   cursor: pointer;
// //   padding-right: 0.5em;
// // }
// // .button--blue {
// //   color: $blue;
// //   display: inline-block;
// //   cursor: pointer;
// //   margin-right: 0.5em;
// // }
// // .button--grey {
// //   color: $btn_able;
// //   display: inline-block;
// //   cursor: pointer;
// //   margin-right: 0.5em;
// // }

// // html {
// //   // 设计图基于 1440px，1rem = 100px;最小 1024px
// //   font-size: calc(100vw / 14.4);
// // }
// // @media screen and (max-width: 1024px) {
// //   html {
// //     font-size: calc(1024px / 14.4);
// //   }
// // }
// // html,
// // body {
// //   width: 100%;
// //   height: 100%;
// //   // min-width: 1024px;
// // }
// // #app {
// //   height: 100%;
// //   position: relative;
// // }
// // body {
// //   background: #fff;
// //   color: #555;
// //   font-size: 14px;
// //   font-family: Microsoft YaHei;
// // }
// // h1,
// // h2,
// // h3,
// // h4,
// // h5,
// // h6 {
// //   font-weight: normal;
// //   font-size: 100%;
// // }
// // address,
// // caption,
// // cite,
// // code,
// // dfn,
// // em,
// // strong,
// // th,
// // var {
// //   font-style: normal;
// //   font-weight: normal;
// // }
// // a {
// //   color: #555;
// //   text-decoration: none;
// // }
// // /*a:hover { text-decoration:underline; }*/
// // img {
// //   border: none;
// // }
// // ol,
// // ul,
// // li {
// //   list-style: none;
// // }
// // input,
// // textarea,
// // select,
// // button {
// //   font: 14px Verdana, Helvetica, Arial, sans-serif;
// // }
// // table {
// //   border-collapse: collapse;
// // }
// // // 按钮文字不可复制
// // button {
// //   user-select: none;
// // }
// // /*清除浮动*/
// // .clearfix:after {
// //   content: ".";
// //   display: block;
// //   height: 0;
// //   clear: both;
// //   visibility: hidden;
// // }
// // .clearfix {
// //   _height: 1%;
// // }

// // /*查询条件样式*/
// // .box {
// //   // height: 100%;
// //   border-top-right-radius: 3px;
// //   border-bottom-right-radius: 3px;
// //   border-bottom-left-radius: 3px;
// //   .el-input {
// //     text-align: left;
// //   }
// //   .el-row {
// //     margin-top: 10px;
// //   }
// //   .el-pagination .el-input__inner {
// //     text-align: center;
// //   }
// // }
// // // 垂直居中
// // .v-center {
// //   position: absolute;
// //   top: 50%;
// //   transform: translate(0, -50%);
// // }
// // // 水平居中
// // .h-center {
// //   position: absolute;
// //   left: 50%;
// //   transform: translate(-50%, 0);
// // }
// // /*表格样式*/
// // .box {
// //   .el-table {
// //     // width: 100%;
// //     margin-top: 10px;
// //   }
// //   .el-table td:not(:last-of-type),
// //   .el-table th:not(:last-of-type) {
// //     border-right: 0;
// //   }
// //   .el-input__inner {
// //     height: 30px;
// //     line-height: 30px;
// //     text-align: left;
// //   }
// //   .el-input__icon {
// //     line-height: 30px;
// //   }
// // }
// // .el-select-dropdown__wrap {
// //   // 选择框至多显示 5 个选项
// //   max-height: 400px;
// // }
// // .ellipsis {
// //   display: inline-block;
// //   overflow: hidden;
// //   text-overflow: ellipsis;
// //   white-space: nowrap;
// //   width: 138px;
// // }
// // .el-form-item__error {
// //   position: relative;
// //   top: 8px;
// //   padding: 0;
// // }
// // // 搜索框样式
// // .search-form {
// //   .el-input {
// //     width: 200px;
// //   }
// //   .el-form-item__content,
// //   .el-form-item__label {
// //     line-height: 30px;
// //   }
// //   .el-form--inline .el-form-item {
// //     margin-right: 30px;
// //     margin-bottom: 16px;
// //   }

// //   .el-form-item.is-success .el-input__inner {
// //     border-color: #dcdfe6;
// //   }
// //   .el-date-editor.el-input {
// //     width: 160px;

// //     .el-input {
// //       width: 160px;
// //     }
// //   }
// // }
// // .el-form-item__label {
// //   color: #999;
// // }
// // .el-pagination__editor.el-input .el-input__inner {
// //   text-align: center;
// // }
// // .hide-error {
// //   .el-form-item__error {
// //     display: none;
// //   }
// //   .el-form-item.is-error .el-input__inner {
// //     border-color: #dcdfe6;
// //   }
// // }
// // // 水平均分 垂直对齐
// // .flex-between {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   .el-form-item__content .el-input-group {
// //     vertical-align: middle;
// //   }
// //   .el-form-item__label {
// //     color: #999;
// //   }
// // }
// // // chrome 49 在某些字符换行时有bug，比如-一
// // // 强制换行，禁止隐藏
// // .el-table .cell,
// // .el-table th div {
// //   overflow: initial !important;
// //   text-overflow: initial !important;
// // }
// // .el-menu--horizontal .el-menu .el-submenu__title {
// //   // 为了防止文字过多导致箭头与问题重叠
// //   padding-right: 50px;
// // }
// // // 需求确认，无需边框
// // .el-submenu__title,
// // .el-menu-item {
// //   border-bottom: 0 !important;
// // }
// // // 垂直对齐 水平居右
// // .flex-end {
// //   display: flex;
// //   align-items: center;
// //   justify-content: flex-end;
// // }
// // // 水平垂直居中
// // .flex-center {
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// // }
// // // 风险话术新增 修改 问卷管理新增修改页面顶部提示
// // .tip-header--blue {
// //   background-color: rgb(232, 246, 255);
// //   border-left: 5px solid rgb(67, 176, 255);
// //   padding: 20px 100px;
// //   border-radius: 5px;
// //   overflow: hidden;
// //   margin-bottom: 30px;

// //   p + p {
// //     margin-top: 1em;
// //   }
// // }
 </style>
